const sizeArray = ['small', 'medium', 'large', 'sm', 'md', 'lg'];
const sizeArrayReadOnly = ['small', 'medium', 'large', 'sm', 'md', 'lg'];
export const fuelSizeArray = [...sizeArrayReadOnly]; // export typed arr
export const getFuelSize = (size) => {
    if (size && sizeArray.includes(size)) {
        // convert abberviation to full word
        if (size === 'sm') {
            return 'small';
        }
        if (size === 'md') {
            return 'medium';
        }
        if (size === 'lg') {
            return 'large';
        }
        return size;
    }
    return 'medium';
};
const inputVariantArray = ['outlined', 'elevated', 'filled'];
const inputVariantArrayReadOnly = ['outlined', 'elevated', 'filled'];
export const fuelInputVariantArray = [...inputVariantArrayReadOnly]; // export typed arr
export const getFuelInputVariant = (variant) => {
    if (variant && inputVariantArray.includes(variant)) {
        return variant;
    }
    return 'outlined';
};
const feedbackTypeArray = ['success', 'error', 'warning', 'info'];
const feedbackTypeArrayReadOnly = ['success', 'error', 'warning', 'info'];
export const fuelFeedbackTypeArray = [...feedbackTypeArrayReadOnly]; // export typed arr
export const getFuelFeedbackType = (feedbackType, defaultType) => {
    if (feedbackType && feedbackTypeArray.includes(feedbackType)) {
        return feedbackType;
    }
    return defaultType || 'info';
};
